import { reactive, readonly } from 'vue';

const state = reactive({
  isVisible: false,
  type: '',
  message: '',
});

let resetMessage;

export default function useFlashMessage() {
  /**
   * フラッシュメッセージを閉じる
   */
  const onClose = () => {
    state.isVisible = false;
  };

  /**
   * フラッシュメッセージを表示
   *
   * @param {string} type
   * @param {string} message
   */
  const showFlashMessage = (type, message) => {
    clearTimeout(resetMessage);

    state.isVisible = true;
    state.type = type;
    state.message = message;

    resetMessage = setTimeout(() => {
      state.isVisible = false;
      state.type = '';
      state.message = '';
    }, 3000);
  };

  return {
    state: readonly(state),
    showFlashMessage,
    onClose,
  };
}
